const CoachOnboardingStatus = {
  COACH_EMAIL_ADDED: 'COACH_EMAIL_ADDED',
};

export {
  CoachOnboardingStatus,
};
